module.exports = __webpack_public_path__ + "static/media/search-icon.325d2108.svg";